import React, { PureComponent } from 'react';
import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleFeedVisibility } from 'containers/Feed/actions';
import PostActions from 'components/FeedList/Post/PostActions';
import WStoreButton from 'components/WStoreButton';
import { isEmbedded } from 'utils/mode';
import { userShape, wallPostShape } from 'utils/shapes';
import WStoreImage from './WallNotification_WStore-Picture.png';
import './WStoreReset.css';

class WStoreReset extends PureComponent {
  render() {
    const { post, user, onDeletePost, toggleFeedVisibility } = this.props;

    const json = JSON.parse(post.message);

    return (
      <div className="feed-wstore-reset">
        <div className="wstore-image-and-body">
          <img className="wstore-image" src={WStoreImage} alt="" />
          <div className="message-body">
            <div className="header">WStore Inventory Reloaded</div>
            {json.hasOwnProperty('resetDatetime') && (
              <div className="reload-datetime">
                {moment
                  .utc(json.resetDatetime, 'YYYY-MM-DD HH:mm:ss Z')
                  .tz(moment.tz.guess())
                  .format('h:mm A, M/D/YY')}
              </div>
            )}
            {!isEmbedded() && (
              <WStoreButton
                to="/wstore"
                onClick={() => toggleFeedVisibility(false)}
              />
            )}
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          onDeletePost={onDeletePost}
          trashIconSize={'small'}
        />
      </div>
    );
  }
}

WStoreReset.propTypes = {
  user: userShape,
  post: wallPostShape,
  onDeletePost: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  toggleFeedVisibility: show => dispatch(toggleFeedVisibility(show))
});

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(WStoreReset);
